/**
 * apps/automations-portal/src/main.tsx
 *
 * React application entry point.
 */
import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from '@/features/auth/AuthProvider';
import { AccessProvider } from '@/features/auth/guards';
import { Toaster } from '@/components/ui/sonner';
import { router } from './router';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element #root not found');

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <AuthProvider>
      <AccessProvider>
        <RouterProvider router={router} />
        <Toaster />
      </AccessProvider>
    </AuthProvider>
  </React.StrictMode>,
);
